import { AnimatePresence, motion } from 'motion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { BannerNotification, Button, Text } from '@frontend/design-system';

interface Props {
  selectedDuration?: number;
  appointmentTypeDuration?: number;
  hideBanner?: boolean;
  onUpdate: (duration: number) => void;
}

export const RecommendedDurationBanner = ({
  selectedDuration,
  appointmentTypeDuration,
  hideBanner,
  onUpdate,
}: Props) => {
  const { t } = useTranslation('scheduleCalendarEvents');
  const shouldShowBanner = !hideBanner && selectedDuration && appointmentTypeDuration;

  return (
    <AnimatePresence>
      {shouldShowBanner && (
        <motion.div
          css={{ overflow: 'hidden', flexShrink: 0 }}
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
        >
          <BannerNotification status='info'>
            <Text weight='bold'>{t('Recommended Duration')}</Text>
            <Text color='light'>
              {t(
                'Your selected duration ({{selectedDuration}} mins) differs from the default for this appointment type ({{appointmentTypeDuration}} mins)',
                {
                  selectedDuration,
                  appointmentTypeDuration,
                }
              )}
            </Text>
            <Button
              size='large'
              variant='tertiary'
              css={{ marginTop: theme.spacing(1) }}
              onClick={() => onUpdate(appointmentTypeDuration)}
            >
              {t('Update to {{appointmentTypeDuration}} Minutes', { appointmentTypeDuration })}
            </Button>
          </BannerNotification>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
